<template>
    <SliceZone :slices="slices" :components="components" />
</template>

<script setup lang="ts">
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {useRoute, createError} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {usePrismicPage} from '~/composables/content/usePrismicPage';
    import {components} from '~/slices/components';

    const props = defineProps<{
        pageType: string;
    }>();

    const route = useRoute();

    const isEnabledFFAlternate = useFeatureFlag('fallback-to-alternate-language');
    const {fetchDocument, fetchDocumentWithFallback, isPrismicDocument} = usePrismicDocument(props.pageType, route.params.uid as string);
    const {data, error} = await useAsyncData('child-page-' + route.params.uid, () =>
        isEnabledFFAlternate.value ? fetchDocumentWithFallback() : fetchDocument(),
    );
    if (error.value) {
        throw createError(error.value);
    }

    const document = isPrismicDocument(data.value) ? data.value : undefined;
    const {slices} = document ? usePrismicPage(document, {head: true}) : {slices: []};
</script>

<style lang="scss">
    @use '~/assets/styles/page';
    @include page.page-style;
</style>
